import { Component, Host, forwardRef, Input, AfterContentInit, Optional } from '@angular/core';
import { source, AttributionLike, TileLoadFunctionType } from 'openlayers';
import { LayerTileComponent } from '../layers';
import { SourceComponent } from './source.component';
import { SourceXYZComponent } from './xyz.component';
import { SourceRasterComponent } from './raster.component';

@Component({
  selector: 'aol-source-osm',
  template: `<div class="aol-source-osm"></div>`,
  providers: [{ provide: SourceComponent, useExisting: forwardRef(() => SourceOsmComponent) }]
})
export class SourceOsmComponent extends SourceXYZComponent implements AfterContentInit {
  declare instance: source.OSM;

  @Input() declare attributions: AttributionLike;
  @Input() declare cacheSize: number;
  @Input() declare crossOrigin: string;
  @Input() declare maxZoom: number;
  @Input() declare opaque: boolean;
  @Input() declare reprojectionErrorThreshold: number;
  @Input() declare tileLoadFunction: TileLoadFunctionType;
  @Input() declare url: string;
  @Input() declare wrapX: boolean;

  constructor(@Host() @Optional() layer: LayerTileComponent, @Host() @Optional() raster?: SourceRasterComponent) {
    super(layer, raster);
  }

  override ngAfterContentInit() {
    if (this.tileGridXYZ) {
      this.tileGrid = this.tileGridXYZ.instance;
    }
    this.instance = new source.OSM(this);
    this._register(this.instance);
  }
}
